<template>
    <div class="_alert" id="_alert" v-if="show">{{text}}</div>
</template>
<script>
export default {
    data(){
        return{
            text:'',
            show:false
        }
    }
}
</script>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");
._alert{
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background: rgba(0,0,0,0.8);
    color: #fff;
    font-size:0.24rem;
    padding: 0.2rem 0.3rem;
    border-radius: 0.1rem;
    max-width: 6.1rem;
}
</style>